

















































































































import { Component, Prop, Emit } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PathCard from './path-card.vue';

import CreateCampaignDialogCountryMixin from '@/views/reports/mixins/flow/create-campaign-dialog-country-mixin';
import CreateCampaignDialogFlowPathErrorsMixin from '@/views/reports/mixins/flow/create-campaign-dialog-flow-path-errors-mixin';
import Vue from 'vue';

@Component({
  components: {
    PathCard,
  }
})
export default class PathSettings extends mixins(CreateCampaignDialogCountryMixin, CreateCampaignDialogFlowPathErrorsMixin) {
  @Prop() 
  rule: any;

  @Prop() 
  ruleIndex: number;

  @Prop() 
  pathIndex: number; 

  @Prop() 
  path: any;

  @Prop()
  allWorkspaceIds: any;

  @Prop() 
  errors: any;

  @Prop() 
  landings: any[];

  @Prop() 
  offers: any[];

  @Prop()
  form: any;

  @Prop()
  offerOptions: Offer[];

  @Prop()
  landingOptions: Landing[];

  @Prop({ default: () => {} })
  errorsDict: any;

  @Emit('duplicate')
  onDuplicate(rule: any, path: any) {}

  @Emit('delete')
  onDelete(rule: any, path: any) {}

  @Emit('focus')
  onFocus() {}

  get activeSwitchDisabled() {
    return this.path.weight <= 0 || isNaN(this.path.weight);
  }

  get path_active() {
    return  !this.activeSwitchDisabled ? this.path.status === 'active' : false; 
  }

  set path_active(val: boolean) {
    this.$emit('change', this.path.status);

    if (val) {
      this.path.status = 'active';
    } else {
      this.path.status = 'inactive';
    }
  }

  get show_delete() {
    if (!this.rule.default) {
      return true;
    } else {
      return this.rule.paths.length > 1
    }
  }

  mounted() {
    this.bus.on('flow-new-landing', this.onBusFlowNewLanding);
    this.bus.on('flow-edit-landing', this.onBusFlowEditLanding);

    this.bus.on('flow-new-offer', this.onBusFlowNewOffer);
    this.bus.on('flow-edit-offer', this.onBusFlowEditOffer);
  }

  beforeDestroy() {
    this.bus.off('flow-new-landing', this.onBusFlowNewLanding);
    this.bus.off('flow-edit-landing', this.onBusFlowEditLanding);

    this.bus.off('flow-new-offer', this.onBusFlowNewOffer);
    this.bus.off('flow-edit-offer', this.onBusFlowEditOffer);
  }

  onBusFlowNewLanding() {
    this.$nextTick(() => {
      this.bus.emit('open-dialog', { name: 'CreateLanding', data: { workspaceId: this.form.workspaceId, onClose: this.addNewLanding } });
    });
  }

  onBusFlowEditLanding(id: string) {
    this.$nextTick(() => {
      this.bus.emit('open-dialog', { name: 'EditLanding', data: { id, onEdit: this.updateLanding } });
    });
    
  }

  onBusFlowNewOffer() {
    this.$nextTick(() => {
      this.bus.emit('open-dialog', { name: 'CreateOffer', data: { onClose: this.addNewOffer } });
    });
  }

  onBusFlowEditOffer(id: string) {
    this.$nextTick(() => {
      this.bus.emit('open-dialog', { name: 'EditOffer', data: { id, onEdit: this.updateOffer } });
    });
  }
  

  addNewOffer(offer: any) {
    this.path.offers.push({
      ...offer,
      weight: 100
    });
  }

  updateOffer(updatedOffer: any) {
    let index = this.offerOptions.findIndex((item: any) => item.id === updatedOffer.id);
    this.$set(this.offerOptions, index, updatedOffer);
    
    // update selected offers in form
    this.form.rules.forEach((rule,ruleIndex)=>{
      rule.paths.forEach((path,pathIndex)=>{
        path.offers.forEach((offer,offerIndex)=>{
          if(offer.id===updatedOffer.id){
            this.form.rules[ruleIndex].paths[pathIndex].offers[offerIndex]={
              ...offer,
              ...updatedOffer
            }
          }
        })
      })
    })
  }

  addNewLanding(landing: any) {
    this.path.landings.push({
      ...landing,
      weight: 100
    });
  }

  updateLanding(updatedLanding: any) {
    let index = this.landingOptions.findIndex((item: any) => item.id === updatedLanding.id);
    this.$set(this.landingOptions, index, updatedLanding);
    
    // update selected landings in form
    this.form.rules.forEach((rule,ruleIndex)=>{
      rule.paths.forEach((path,pathIndex)=>{
        path.landings.forEach((landing,landingIndex)=>{
          if(landing.id===updatedLanding.id){
            this.form.rules[ruleIndex].paths[pathIndex].landings[landingIndex]={
              ...landing,
              ...updatedLanding
            }
          }
        })
      })
    })
  }

  getLandingName(item: any) {
    if(!item) {
      return '';
    }

    return item.nameFull;
  }

  getOfferName(item: any) {
    if(!item) {
      return '';
    }

    let result = item.nameFull;
    if(item.affiliateNetworkName) {
      result += ` (${item.affiliateNetworkName})`;
    }
    return result;
  }
}
